<template>
  <div class="product-item-image" :id="divId">
      <div class="product-item-image-wrapper">
        <!-- <img src="../../assets/iphone-7-black.png" class="product-item-image-overlay" v-if="product.device.color == 'black'"> -->
        <div class="cover-demo-bar" v-if="product.isDemoVideo">

        </div>
        <img src="../../assets/iphone-7-white.png" class="product-item-image-overlay" v-if="product.device.color == 'black'">
        <img src="../../assets/iphone-7-white.png" class="product-item-image-overlay" v-if="product.device.color == 'white'">
        <!-- <img :src="currentImage" class="product-item-image-content"> -->
        <video :id="videoId" :src="currentImage" muted playsinline autoplay loop class="attach-video-holder">

        </video>

        <div class="product-item-image-gallery" v-if="currentImageOptions > 1">
          <span v-for="(url, imageKey) in product.images" v-on:click="setGalleryImage(imageKey)"
                class="product-item-gallery-item"
                v-bind:class="[currentImageKey == imageKey ? 'active-class' : '' ]">{{ imageKey }}</span>
        </div>
      </div>
  </div>
</template>

<script>
import productScrollHelper from './productScrollHelper'

import eventDispatcher from '../../events/dispatch'

export default {
  props: [ 'product' ],
  data() {
    return {
      currentImageKey: undefined,
      currentImageOptions: 0,
      videoBecameVisible: false
    }
  },
  mounted() {
    this.scrollListener()
  },
  methods: {
    restartVideo() {
      let videoElement = document.getElementById(this.videoId)
      if (videoElement) {
        videoElement.currentTime = 0
      }
    },
    setGalleryImage(key) {
      eventDispatcher('attachGalleryProductToggled', {
        product: this.product.slug,
        gallery_view: key
      })
      this.currentImageKey = key
    },
    scrollListener() {
      let self = this
      $(window).scroll(function(){
        let videoBecameVisible = productScrollHelper.scrollListener(self.divId, 500)
        self.updateVideoBecameVisible(videoBecameVisible)
      });
    },
    updateVideoBecameVisible(shouldShow) {
      if (shouldShow && !this.videoBecameVisible) this.videoBecameVisible = true
      if (!shouldShow && this.videoBecameVisible) this.videoBecameVisible = false
    },
  },
  computed: {
    divId() {
      return `product-${this.product.slug}`
    },
    videoId() {
      return `video-${this.product.slug}`
    },
    currentImage() {
      this.currentImageOptions = 0
      let currentKey = this.currentImageKey
      for (let key in this.product.images) {
        this.currentImageOptions++
        if (!currentKey) currentKey = key
      }

      this.currentImageKey = currentKey
      return this.product.images[currentKey]
    }
  },
  watch: {
    videoBecameVisible() {
      if (this.videoBecameVisible) {
        this.restartVideo()
      }
    }
  }
}
</script>

<style scoped>

  .product-item-image {
    display: inline-block;
    width: 30%;
    vertical-align: top;
  }

  @media only screen and (max-width: 650px) {
    .product-item-image {
      display: block;
      width: 100%;
      margin-top: 24px;
    }
  }

  .product-item-image-wrapper {
    display: inline-block;
    vertical-align: top;
  }

  .product-item-image-content {
    margin: 57px 11px;
    border: 12px;
    height: 406px;
  }

  @media only screen and (max-width: 800px) {
    .product-item-image-content {
      margin: 70px 14px;
      border: 12px;
      width: auto;
      height: 466px;
    }
  }

  .product-item-image-overlay {
    position: absolute;
    width: 250px;
  }

  @media only screen and (max-width: 800px) {
    .product-item-image-overlay {
      width: 240px;
    }
  }

  @media only screen and (max-width: 650px) {
    .product-item-image-overlay {
      width: 275px;
    }
  }



  .product-item-image-gallery {

  }

  .product-item-gallery-item {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1px;
    margin: 4px;
    padding: 4px 6px;
    font-weight: lighter;
    border-radius: 2px;
    color: #333;
    transition: ease-in 0.125s;
    cursor: pointer;
  }

  .active-class {
    background: black;
    color: white;
  }

  .attach-video-holder {
    margin: 58px 14px;
    border: 12px;
    width: 222px;
    height: 396px;
  }

  @media only screen and (max-width: 800px) {
    .attach-video-holder {
      margin: 24px 15px;
      border: 12px;
      width: 211px;
      height: 440px;
    }
  }

  @media only screen and (max-width: 650px) {
    .attach-video-holder {
      margin: 69px 11px;
      border: 12px;
      width: 268px;
      height: 457px;
    }
  }

  .cover-demo-bar {
    display: block;
    position: absolute;
    background: #f8f8f8;
    width: 225px;
    height: 12px;
    z-index: 1;
    margin-top: 60px;
    margin-left: 14px;
  }

  @media only screen and (max-width: 800px) {
    .cover-demo-bar {
      margin-top: 57px;
      height: 12px;
      width: 216px;
    }
  }

  @media only screen and (max-width: 650px) {
    .cover-demo-bar {
      margin-top: 67px;
      height: 20px;
      width: 261px;
    }
  }

</style>



// WEBPACK FOOTER //
// ProductImageComponent.vue?f9ee8482